import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkQuery } from 'src/operations/query';
import { QueryBuilderHeader } from 'src/modules/query-builder/components';
import {
  getTargets,
  getOriginalTargets,
} from '../../../../selectors/queryBuilder';
import { requestCreateAudience } from '../../../../actions';

const CreateAudienceHeader: FC<any> = ({ onCreateAudienceModalClose }) => {
  const queryBuilder = useSelector((state: any) => state.queryBuilder);
  const dispatch = useDispatch();
  const originalTargets = useSelector(getOriginalTargets);
  const targets = useSelector(getTargets);
  const conversation = useSelector((state: any) => state.conversation);
  const createAudienceModal = useSelector(
    (state: any) => state.createAudienceModal
  );

  const isLoading =
    queryBuilder.isLoading ||
    conversation.isLoading ||
    createAudienceModal.isLoading;
  const selectedTarget =
    queryBuilder.targets && queryBuilder.targets[queryBuilder.target_selected];
  const isQueryValid = useMemo(() => {
    if (!selectedTarget) {
      return false;
    }
    const { target_query } = selectedTarget;
    const checked = checkQuery(target_query);
    return checked;
  }, [selectedTarget]);

  const handleOnRequestCreateAudience = useCallback(
    app => {
      const queryData = originalTargets?.[0] || targets[0];
      dispatch(requestCreateAudience(queryData, app));
      window.dispatchEvent(
        new CustomEvent('TOGGLE_REPO_COLLAPSED', {
          detail: { isCollapsed: true },
        })
      );
    },
    [dispatch, targets, originalTargets]
  );

  return (
    <QueryBuilderHeader
      isQueryLoading={isLoading}
      isQueryValid={isQueryValid}
      onCreateAudienceModalClose={onCreateAudienceModalClose}
      onRequestCreateAudience={handleOnRequestCreateAudience}
    />
  );
};

export default CreateAudienceHeader;
